import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Separator.sass';

export const Separator = ({ color = 'primary', className }) => {
  const classes = classNames('separator', {
    [`${color}-color`]: true,
    [className]: !!className,
  });

  return <div className={classes} />;
};

Separator.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'white', 'homepage']),
  className: PropTypes.string,
};

Separator.defaultProps = {
  color: 'primary',
  className: '',
};
